/**
 * @file 预约按钮组件
 * @description 绿色圆角预约按钮，支持禁用状态和加载状态
 */

import React from "react";
import "./index.less";

/**
 * BookingButton 组件 Props 接口
 */
export interface BookingButtonProps {
  /** 点击回调 */
  onClick?: () => void;
  /** 是否禁用 */
  disabled?: boolean;
  /** 按钮文本 */
  text?: string;
  /** 禁用时的提示文本 */
  disabledText?: string;
  /** 自定义类名 */
  className?: string;
  /** 是否正在加载 */
  loading?: boolean;
}

/**
 * 立即预约按钮组件
 * 实现绿色圆角按钮样式，支持禁用和加载状态
 */
const BookingButton: React.FC<BookingButtonProps> = ({
  onClick,
  disabled = false,
  text = "立即预约",
  disabledText,
  className = "",
  loading = false,
}) => {
  /**
   * 处理按钮点击
   * 阻止事件冒泡，禁用/加载状态下不触发回调
   */
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!disabled && !loading && onClick) {
      onClick();
    }
  };

  const buttonText = disabled && disabledText ? disabledText : text;

  return (
    <button
      className={`booking-button ${disabled ? "disabled" : ""} ${loading ? "loading" : ""} ${className}`}
      onClick={handleClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <span className="loading-spinner" />
      ) : (
        <span className="button-text">{buttonText}</span>
      )}
    </button>
  );
};

export default BookingButton;
